import { buildRoute, isRoute, RouteNames } from '@/routes'
import { LoadingRoute } from '@/routes/LoadingRoute'
import { getCurrentOrganization } from '@/store/helpers'
import { OnboardingStep } from '@repo/shared/dtos/organization'
import { useAsyncData } from '@repo/ui/dataProvider'
import { ReactNode, useMemo } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

export function CheckOnboarding({ children }: { children: ReactNode }) {
  const location = useLocation()
  const pathname = useMemo(() => location.pathname, [location.pathname])
  const isOnboardingRoute = isRoute(RouteNames.Onboarding, pathname)

  const { data, isError, isLoading, isFulfilled } = useAsyncData([
    getCurrentOrganization,
  ])

  if (isError) return <Navigate to={RouteNames.Root} />

  if (isLoading) return <LoadingRoute />

  if (isFulfilled) {
    const [organization] = data
    const isOnboardingCompleted =
      organization.onboarding.step === OnboardingStep.COMPLETED

    // Handle onboarding route
    if (isOnboardingRoute) {
      return isOnboardingCompleted ? (
        <Navigate to={buildRoute(RouteNames.Organizations, organization.id)} />
      ) : (
        children
      )
    }

    // Handle non-onboarding route
    return isOnboardingCompleted ? (
      children
    ) : (
      <Navigate
        to={buildRoute(RouteNames.Organizations, [
          organization.id,
          RouteNames.Onboarding,
        ])}
      />
    )
  }

  return null
}
